import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
	selector: "attachment-position-movement-form",
	standalone: true,
	imports: [
		CommonModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		MatCheckboxModule,
		FormsModule,
		TranslateModule,
		ReactiveFormsModule
	],
	templateUrl: "./attachmentPositionMovementForm.component.html",
	styleUrl: "./attachmentPositionMovementForm.component.scss"
})
export class AttachmentPositionMovementFormComponent implements OnInit {
	@Input() parentForm: FormGroup;
	@Input() isUpperJaw: boolean;
	@Input() nestedFormGroupName: string;
	jawFormControlName: string;

	readonly labialBuccalFormControlName = "labialBuccal";
	readonly lingualPalatalFormControlName = "lingualPalatal";
	readonly scheuProtocolFormControlName = "scheuProtocol";

	labialBuccalFormControl: FormControl;
	lingualPalatalFormControl: FormControl;
	scheuProtocolFormControl: FormControl;

	ngOnInit(): void {
		this.jawFormControlName = this.isUpperJaw ? 'uj' : 'lj';
		this.labialBuccalFormControl = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${this.labialBuccalFormControlName}`) as FormControl;
		this.lingualPalatalFormControl = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${this.lingualPalatalFormControlName}`) as FormControl;
		this.scheuProtocolFormControl = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${this.scheuProtocolFormControlName}`) as FormControl;

		this.labialBuccalFormControl?.markAsTouched();
		this.lingualPalatalFormControl?.markAsTouched();

		this.scheuProtocolFormControl.valueChanges.subscribe(isChecked => {
			if(isChecked){
				 this.labialBuccalFormControl.patchValue('', { emitEvent: false });
				 this.lingualPalatalFormControl.patchValue('', { emitEvent: false });
				 this.labialBuccalFormControl.clearValidators();
				 this.lingualPalatalFormControl.clearValidators();
			}else{
				this.labialBuccalFormControl.setValidators([Validators.required]);
				this.lingualPalatalFormControl.setValidators([Validators.required]);
			}
			this.labialBuccalFormControl.updateValueAndValidity();
			this.lingualPalatalFormControl.updateValueAndValidity();
		})
	}
}
